// @ts-strict

import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

declare var AppleID: {
  auth: {
    init: (arg0: {
      clientId: string;
      scope: string;
      redirectURI: string;
      state: string;
      nonce: string;
      usePopup: boolean; //or false defaults to false
    }) => void;
    signIn: () => any;
  };
};

@Injectable({
  providedIn: 'root'
})
export class AppleSignInService {
  constructor() {}

  parseJwt(token: string) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  public async apple() {
    try {
      console.log(AppleID);
      AppleID.auth.init({
        // clientId: 'service.pub.mylead.global',
        clientId: 'pl.mylead.app.service',
        scope: 'name email',
        redirectURI: `https://${environment?.domain}/login`,
        state: 'init',
        nonce: 'test',
        usePopup: true //or false defaults to false
      });
      const data = await AppleID.auth.signIn();
    } catch (error) {
      console.log(error);
    }
  }
}
